import * as Leaflet from "leaflet";
import pin from "./marker-icon.svg";

type Place = {
    lat: number;
    lon: number;
    address: {
        city: string;
        state_district: string;
        state: string;
        country: string;
    };
};

const mapWrapper: HTMLElement = document.querySelector("#map");
export default class Map {
    mapWrapper: HTMLElement | null;

    constructor() {
        this.mapWrapper = document.querySelector("#map");
        if (this.mapWrapper) {
            this.initMap();
        }
    }

    fetchPlaceData = async (address: string): Promise<Place[]> => {
        const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${address}`);
        return await response.json();
    };

    initMap = async () => {
        const address: string = mapWrapper.getAttribute("data-address");
        const data: Place[] = await this.fetchPlaceData(address);
        const place: Place = data.length > 0 ? data[0] : null;

        const map = Leaflet.map("map").setView([place.lat, place.lon], 16);

        Leaflet.tileLayer("https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png", {
            attribution:
                '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
            maxZoom: 20,
        }).addTo(map);

        /* add marker icon */
        const pinIcon = new Leaflet.Icon({
            iconAnchor: [9, 25],
            iconSize: [21, 26.25],
            iconUrl: pin,
        });
        const marker = Leaflet.marker([place.lat, place.lon], { icon: pinIcon }).addTo(map);

        /* Text */
        marker.bindPopup(address, { offset: [1, -10], maxWidth: 200 }).openPopup();
    };
}
